import React from "react";

const Empty = ({ src, writeup }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <img src={src} alt="empty state " />
      <p className=" opacity-50 text-sm">{writeup}</p>
    </div>
  );
};

export default Empty;
